import { render, staticRenderFns } from "./admin-form.vue?vue&type=template&id=697381d9&"
import script from "./admin-form.vue?vue&type=script&lang=js&"
export * from "./admin-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports